import React, { useEffect, useState } from 'react'
import { Dropdown } from 'semantic-ui-react'
import { useTalentApi } from '../../store/mainContext'
// import AddCompanyModal from '../modals/addCompanyModal';
import AddContactModal from '../modals/addContactModal'

const ContactSelect = ({
  allowAdditions,
  onChange,
  name,
  fluid,
  error,
  placeholder,
  value,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [showAddModal, setShowAddModal] = useState(false)
  const [selectedValue, setSelectedValue] = useState(null)
  const [options, setOptions] = useState([])

  const api = useTalentApi()

  useEffect(() => {
    api
      .get(`contacts`)
      .then(({ data }) => {
        setOptions(
          data.map((c) => ({
            text: `${c.name} (${c.email})`,
            value: c._id,
            key: c._id,
          }))
        )
      })
      .finally(() => setIsLoading(false))
  }, [api])

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  const handleAdd = (e, payload) => {
    setSelectedValue(payload.value)
    setShowAddModal(true)
  }

  const handleCancel = () => {
    setSelectedValue(null)
    setShowAddModal(false)
    onChange && onChange(null, { name, value: null })
  }

  const handleCreated = (newvalue) => {
    const selectedOption = {
      text: newvalue.name,
      value: newvalue._id,
      key: newvalue._id,
    }

    setOptions([...options, selectedOption])
    setSelectedValue(selectedOption.value)

    setShowAddModal(false)
    console.log('selected', selectedOption)
    onChange && onChange(null, { name, value: selectedOption.value })
  }

  const handleOnChange = (e, t) => {
    setSelectedValue(t.value)

    onChange && onChange(e, t)
  }

  return (
    <React.Fragment>
      <Dropdown
        key={selectedValue}
        name={name}
        // onSearchChange={handleSearchChange}
        onChange={handleOnChange}
        placeholder={placeholder}
        search
        allowAdditions={allowAdditions}
        fluid={fluid || true}
        selection
        options={options}
        loading={isLoading}
        onAddItem={handleAdd}
        value={selectedValue}
        error={error}
        clearable={true}
      />

      <AddContactModal
        open={showAddModal}
        defaults={{ name: selectedValue }}
        onCreated={handleCreated}
        onCancel={handleCancel}
      />
    </React.Fragment>
  )
}

export default ContactSelect
